export const ENTITIES_STORE_KEY = 'entities';

export const PAGES_STORE_KEY = 'pages';

export const UI_KEY = 'ui';

export const AUTH_STORE_KEY = 'auth';
